import { SearchResult } from '@shared/models/search/search-result';

export interface mapResultsState {
  cards: Array<SearchResult>;
}

export interface mapResultsReducersState {
  data: {
    cards: Array<SearchResult>;
  };
}

export const initialState: mapResultsState = {
  cards: [],
};
